import moment from 'moment';
import sessionReader from '../store/readHelpers/SessionReader';
import { t } from './i18nService';

function zeroPad(number) {
    return (number < 10 ? '0' : '') + number;
}

export function getSystemTimeZone() {
    return moment.tz !== undefined ? moment.tz.guess() : undefined;
}

function getTimeZone() {
    return sessionReader.getPrintParam('time_zone', getSystemTimeZone());
}

function formatDateTimeWithMoment(date, timeZone = getTimeZone()) {
    return moment(date)
        .tz(timeZone)
        .format('DD.MM.YYYY HH:mm');
}

function isDateToday(date, timeZone = getTimeZone()) {
    return moment(date)
        .tz(timeZone)
        .isSame(new Date(), 'day');
}

function formatDateWithMoment(date, timeZone = getTimeZone()) {
    return moment(date)
        .tz(timeZone)
        .format('D MMMM YYYY');
}

function formatDateTimeManually(date) {
    const year = date.getFullYear();
    const month = zeroPad(date.getMonth() + 1);
    const dateStr = zeroPad(date.getDate());
    const hours = zeroPad(date.getHours());
    const minutes = zeroPad(date.getMinutes());

    return `${dateStr}.${month}.${year} ${hours}:${minutes}`;
}

function isToday(inputDate) {
    const today = new Date();
    return today.setHours(0, 0, 0, 0) === inputDate.setHours(0, 0, 0, 0);
}

function formatDateManually(date) {
    if (!moment(date).isValid() || isToday(date)) {
        return t('generic.today');
    }

    const lang = sessionReader.getLanguage();
    const year = date.getFullYear();
    const month = date.toLocaleString(lang, { month: 'long' });
    const dateStr = date.getDate();

    return `${dateStr} ${month} ${year}`;
}

const dateTimeService = {
    formatDateTime(date) {
        try {
            if (moment.tz !== undefined) {
                return formatDateTimeWithMoment(date);
            }

            return formatDateTimeManually(date);
        } catch (error) {
            window.console.error(error);
            return '-';
        }
    },

    formatDate(date) {
        try {
            if (moment.tz !== undefined) {
                if (!isDateToday(date)) {
                    return t('generic.today');
                }
                return formatDateWithMoment(date);
            }

            return formatDateManually(date);
        } catch (error) {
            window.console.error(error);
            return '-';
        }
    },
};

export default dateTimeService;
